import * as buttons from 'smg/buttons';
import { CreateContact } from 'smg/customer-api/contact';
import { Session } from 'smg/customer-api/session';
import * as phone from 'smg/phone';
import * as uploads from 'smg/uploads';
import { Relref } from '../hugo';

void main();

async function main() {
    const fullName = document.querySelector('#full-name') as HTMLInputElement;
    const company = document.querySelector('#company') as HTMLInputElement;
    const email = document.querySelector('#email') as HTMLInputElement;
    const notes = document.querySelector('#notes') as HTMLTextAreaElement;
    const $phone = document.querySelector('#phone') as HTMLInputElement;
    const form = document.querySelector('#form') as HTMLFormElement;
    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const confirm = form.querySelector('[type="submit"]') as HTMLButtonElement;
    const alert = form.querySelector('.alert') as HTMLElement;
    const uploadsLabel = form.querySelector('#uploads') as HTMLLabelElement;
    const sms = document.querySelector('#sms-opt-in') as HTMLInputElement;

    alert.parentElement?.removeChild(alert);
    alert.classList.remove('d-none');

    try {
        const sess = await Session();
        fullName.value = sess.user.fullName();
        email.value = sess.user.emailAddress.email;
        $phone.value = sess.user.phoneNumber.phone;
        company.value = sess.user.company ?? '';
    } catch (err) {
        console.error(err);
    }

    const showAlert = (type: 'generic' = 'generic') => {
        const a = alert.cloneNode(true) as HTMLElement;
        const msg = a.querySelector(`.${type}`);
        msg?.classList.remove('d-none');

        // Next to the submit button, not the top of the form: this fires when the
        // user clicks Submit at the bottom of a long form, and a message above the
        // first field is off-screen behind the sticky header.
        confirm.before(a);
    };

    const hideAlert = () => {
        const a = form.querySelector('.alert');
        a?.parentElement?.removeChild(a);
    };

    const p = new phone.Input($phone);

    const u = new uploads.Uploader(uploadsLabel, {
        confirmBtn: confirm,
        thumbnails: document.querySelector('#uploads-thumbnails') as HTMLElement,
    });

    form?.addEventListener('submit', e => {
        e.preventDefault();

        hideAlert();

        fieldset.setAttribute('disabled', 'disabled');
        buttons.Start(confirm);
        CreateContact({
            name: fullName.value,
            company: company.value,
            phone: p,
            email: email.value,
            content: notes.value,
            uploader: u,
            preferSMS: sms.checked,
            $reCaptchaPlaceholder: document.querySelector('.contact-recpatcha-parent') as HTMLElement,
        }).then(() => {
            window.location.href = Relref('/contact/success');
        }).catch(err => {
            console.error(err);
            fieldset.removeAttribute('disabled');
            buttons.Stop(confirm);

            showAlert();
        });
    });
}